var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgNotifications = function SvgNotifications(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0D2976",
    d: "M7.633 14.876c0 .09-.09.09-.182 0a1.544 1.544 0 0 1-.363-2.089c0-.09.091-.09.182 0 .09.091.09.091 0 .182a1.16 1.16 0 0 0 .272 1.634q.074.127.091.273m6.991 1.997c-.454-1.544-.545-3.904 1.816-7.264a4.03 4.03 0 0 0-.817-5.084l.272-.273a.74.74 0 0 0-.181-1.089.74.74 0 0 0-1.09.182.33.33 0 0 0-.09.272 3.914 3.914 0 0 0-4.994.999C7.088 7.976 4.818 8.7 3.184 8.883a1.04 1.04 0 0 0 .272 1.453l3.087 2.179a2.154 2.154 0 1 0 3.541 2.451l3.087 2.18a1.15 1.15 0 0 0 1.453-.273"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgNotifications);
export default ForwardRef;